import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditTmm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.9 9.875C9.08331 9.875 10.05 8.99576 10.05 7.91979C10.05 6.62037 7.9 4.5 7.9 4.5C7.9 4.5 5.75 6.62037 5.75 7.91979C5.75 8.99576 6.71669 9.875 7.9 9.875Z",
		fill: "currentColor",
		fillOpacity: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.75 9.5625V12.375H14.25V9.5625M1.75 9.5625H4.63462M1.75 9.5625V5.8125M1.75 5.8125V3H14.25V5.8125M1.75 5.8125H5.11538M14.25 5.8125H10.8846M14.25 5.8125V9.5625M14.25 9.5625H11.3654M9.78571 3V4.70455M5.76786 3V4.70455M5.76786 11.9489V10.2443M9.78571 11.9489V10.2443",
		stroke: "currentColor",
		strokeOpacity: 1,
		strokeWidth: 1.2,
		strokeLinejoin: "round"
	})]
});
export default SvgEditTmm;
